/** перенес из ./main.ts -> уменьшилось кол-во круговых зависимостей */
export class Transliterate {
  static productTitle(title: string) {
    if (!title) return '';

    const wordsAmount = title.length > 50 ? 3 : 6;

    return this.transliterateTitle(title, wordsAmount);
  }

  static transliterateTitle(title: string, wordsAmount = 4) {
    return this.transliterate(
      title
        .toLowerCase()
        .replace(/[^а-яa-z\s\d-]/gi, '')
        .split(/\s/, wordsAmount)
        .join('-') + '-',
    );
  }

  static transliterate(word: string) {
    let answer = '';
    const a = {} as any;

    a['Ё'] = 'Yo';
    a['Й'] = 'J';
    a['Ц'] = 'C';
    a['У'] = 'U';
    a['К'] = 'K';
    a['Е'] = 'E';
    a['Н'] = 'N';
    a['Г'] = 'G';
    a['Ш'] = 'Sh';
    a['Щ'] = 'Sch';
    a['З'] = 'Z';
    a['Х'] = 'Kh';
    a['Ъ'] = '';
    a['ё'] = 'yo';
    a['й'] = 'j';
    a['ц'] = 'c';
    a['у'] = 'u';
    a['к'] = 'k';
    a['е'] = 'e';
    a['н'] = 'n';
    a['г'] = 'g';
    a['ш'] = 'sh';
    a['щ'] = 'sch';
    a['з'] = 'z';
    a['х'] = 'kh';
    a['ъ'] = '';
    a['Ф'] = 'F';
    a['Ы'] = 'Y';
    a['В'] = 'V';
    a['А'] = 'A';
    a['П'] = 'P';
    a['Р'] = 'R';
    a['О'] = 'O';
    a['Л'] = 'L';
    a['Д'] = 'D';
    a['Ж'] = 'Zh';
    a['Э'] = 'E';
    a['ф'] = 'f';
    a['ы'] = 'y';
    a['в'] = 'v';
    a['а'] = 'a';
    a['п'] = 'p';
    a['р'] = 'r';
    a['о'] = 'o';
    a['л'] = 'l';
    a['д'] = 'd';
    a['ж'] = 'zh';
    a['э'] = 'e';
    a['Я'] = 'Ya';
    a['Ч'] = 'Ch';
    a['С'] = 'S';
    a['М'] = 'M';
    a['И'] = 'I';
    a['Т'] = 'T';
    a['Ь'] = '';
    a['Б'] = 'B';
    a['Ю'] = 'Yu';
    a['я'] = 'ya';
    a['ч'] = 'ch';
    a['с'] = 's';
    a['м'] = 'm';
    a['и'] = 'i';
    a['т'] = 't';
    a['ь'] = '';
    a['б'] = 'b';
    a['ю'] = 'yu';
    a[' '] = '-';

    for (const char of word) {
      answer += a[char] === undefined ? char : a[char];
    }

    return answer;
  }
}
